<template>
  <card>
    <div class="row">
      <div class="col-12">
        <div class="welcome">
          <h3>Welcome to Sensoreal</h3>
          <p>To create your first page click on the <strong>PAGES</strong> tab in the side menu and then the <strong>ADD NEW PAGE</strong> button.</p>
          <p>Fill out all the fields and click <strong>CREATE PAGE</strong>.</p>
        </div>
        <ol>
          <li v-for="page in pages" :key="page._id">
            {{ page.heading.en }}
          </li>
        </ol>
      </div>
    </div>   
  </card>
</template>
<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import { FETCH_PAGE, FETCH_PAGES } from '@/store/actions.type'

export default {

  computed: {
    ...mapGetters([
      "pages",
      "langs"
    ]),
  },

  methods: {
    dataFormat: function(a, b) {
      if (b) return b + "%";
      return a;
    }
  },

  mounted() {
    this.$store.dispatch(FETCH_PAGES);
  },
};
</script>
<style>
</style>
